import {IconButton, Stack} from "@mui/material";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import {Highlighter} from "../../common/Highlighter";
import React from "react";
import {Proposal} from "../../../types/Proposal";
import {ProposalFilter} from "../../../service/proposal.service";

interface Props {
    row: Proposal,
    filter: ProposalFilter
    setShowMap: (p:Proposal) => void
}

export function ProposalAddressCell({setShowMap, row, filter}:Props) {

    const href = row.maps
        ? row.maps
        : (row.lat && row.lng
            ? "https://www.google.com/maps?q=" + row.lat + "," + row.lng
            : undefined);
    let map;
    if (!href) {
        map = <IconButton>
            <TravelExploreIcon/>
        </IconButton>
    } else {
        map = <IconButton onClick={() => setShowMap(row)}>
            <TravelExploreIcon color={"info"}/>
        </IconButton>
    }

    return <Stack alignItems={"center"} flexDirection={"row"} gap={'5px'}>
        <Highlighter text={row.address} search={filter.address}/>
        {map ? <Stack justifyContent={"center"}>{map}</Stack> : undefined}
    </Stack>
}